(function() {
	'use strict';

	angular.module('prelimApp').controller('PrelimUpdateDialogController',
			PrelimUpdateDialogController);

	PrelimUpdateDialogController.$inject = [ '$scope', '$uibModalInstance',
			'PrelimService', 'prelimID', 'CONST_PRELIM', 'Upload',
			'authExpiredInterceptor', '$window', '$base64' ];

	function PrelimUpdateDialogController($scope, $uibModalInstance,
			PrelimService, prelimID, CONST_PRELIM, Upload,
			authExpiredInterceptor, $window, $base64) {
		var prelimDlgCtr = this;
		var self = $scope;
		self.CONST_PRELIM = CONST_PRELIM;

		prelimDlgCtr.cancel = cancel;
		prelimDlgCtr.datePickerOpenStatus = {};
		prelimDlgCtr.datePickerOpenStatus.acceptedDate = false;

		prelimDlgCtr.openCalendar = function(date) {
			prelimDlgCtr.datePickerOpenStatus[date] = true;
		};

		prelimDlgCtr.initPage = function() {
			prelimDlgCtr.acceptedDate = new Date();	
			prelimDlgCtr.dto = {};
			prelimDlgCtr.disable = false;
			prelimDlgCtr.file = {
				name : '',
				size : 0,
				type : ''
			};
			var prelimIDBase64 = $base64.encode(prelimID);
			PrelimService.get({
				uri : 'getPrelimRewardDetail',
				prelimID : prelimIDBase64
			}, function(result) {
				prelimDlgCtr.dto = result;
				if(prelimDlgCtr.dto.prelimID != null && prelimDlgCtr.dto.status == '1') {
					prelimDlgCtr.disable = true;
				}
				if(prelimDlgCtr.dto.acceptedDate != null) {
					prelimDlgCtr.dto.acceptedDate = new Date(prelimDlgCtr.dto.acceptedDate);
				}
				prelimDlgCtr.file.name = result.fileName;
				prelimDlgCtr.file.size = result.contentType;
				prelimDlgCtr.file.type = result.dataType;
			});

		};

		prelimDlgCtr.ok = function() {
			var data = [];

			data['updateDTO'] = new Blob([ JSON.stringify(prelimDlgCtr.dto) ], {
				type : "application/json"
			});
			data['file'] = prelimDlgCtr.file;

			$scope.loading = true;
			if(prelimDlgCtr.dto.status == '1') {			
				PrelimService.post({
					uri : 'updatePrelim'
				}, prelimDlgCtr.dto, function(result) {
					$uibModalInstance.close();
				});
			} else {
				Upload
						.upload(
								{
									url : GLOBAL_URL
											+ '/api/ga/prelim/updatePrelimWithFile?access_token='
											+ authExpiredInterceptor.getToken(),
									data : data,
									arrayKey : ''
								})
						.then(
								function(result) {
									$uibModalInstance.close();
									$scope.loading = false;
								}, function(result) {
									$uibModalInstance.close();
									$scope.loading = false;
								}, function(evt) {
									$uibModalInstance.close();
									$scope.loading = false;
								});
			}
		};

		function cancel() {
			$uibModalInstance.dismiss();
		};

		prelimDlgCtr.searchAgent = function() {
			var code = prelimDlgCtr.dto.agentCode;
			if (code == undefined || code == null || code == '') {
				prelimDlgCtr.dto.agentName = '';
				return;
			}
			if (code != undefined || code != '') {
				var numCode = Number(code);
				if (numCode < 10000000)
					numCode += 60000000;
				prelimDlgCtr.dto.agentCode = numCode.toString();
			}
			PrelimService.get({
				uri : 'get-agent',
				agentCode : prelimDlgCtr.dto.agentCode
			}, function(result) {
				prelimDlgCtr.dto.agentName = result.agentName;
			});
		};

		prelimDlgCtr.getAttachmentInfo = function() {
			var prelimIDBase64 = $base64.encode(prelimID);
			PrelimService.get({
				uri : 'getAttachmentInfo',
				prelimID : prelimIDBase64
			}, function(result) {
				if (result !== null) {
					prelimDlgCtr.download(result);
				}
			});
		}

		prelimDlgCtr.download = function(attach) {
			// danh cho ie
			if (navigator.appVersion.toString().indexOf('.NET') > 0) { // for
				// IE
				// browser
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				} else {
					var blob = new Blob([ attach ], {
						type : attach.dataType
					});
					window.navigator.msSaveBlob(blob, attach.dataName);
				}
			} else {
				// truong hop file da luu duoi database
				if (attach.content != undefined) {
					var byteCharacters = atob(attach.content);
					var byteNumbers = new Array(byteCharacters.length);
					for (var i = 0; i < byteCharacters.length; i++) {
						byteNumbers[i] = byteCharacters.charCodeAt(i);
					}
					var byteArray = new Uint8Array(byteNumbers);
					var blob = new Blob([ byteArray ], {
						type : attach.dataType
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = attach.dataName;
					aTag.click();
				} else {
					// truong hop file luu tam tren man hinh
					var blob = new Blob([ prelimDlgCtr.file ], {
						type : prelimDlgCtr.file.type
					});
					var url = $window.URL || $window.webkitURL;
					var aTag = document.createElement("a");
					aTag.style = "display: none";
					aTag.href = url.createObjectURL(blob);
					aTag.download = prelimDlgCtr.file.name;
					aTag.click();
				}
			}
		}
	}
})();
